function triggerCartWiggle() {
    const iconCart = document.querySelector('.icon-cart');
    iconCart.classList.add('wiggle');

    // Remove the wiggle class after the animation duration (333ms)
    setTimeout(() => {
        iconCart.classList.remove('wiggle');
    }, 600);
}

function setCookie_CartGifts(name, value, m) {
  let expires = "";
  if (m) {
    let date = new Date();
    date.setTime(date.getTime() + (m  * 60 * 1000)); //minutos
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

function getCookie_CartGifts(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

function add_to_cart_grid(variantid,qty){
  var id = variantid;
  var q = qty;
  var ajax = {
      type: "POST",
      url: "/cart/add.js",
      data: "quantity=" + q + "&id=" + id,
      dataType: "json",
      success: function (n) {
        var cart = new theme.CartDrawer
        cart.init();
        triggerCartWiggle();
      },
      error: function (n, c) {
         console.log('fail');
      }
   };
  jQuery.ajax(ajax)
  const addToCartFDV = new CustomEvent("addToCartFDV", {detail: {variantId: variantid}});
  document.dispatchEvent(addToCartFDV);
}

function add_to_cart_gift(variantid, qty) {
  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: "quantity=" + qty + "&id=" + variantid,
      dataType: "json",
      success: function (response) {
        var cart = new theme.CartDrawer();
        cart.init();
        resolve(response);
      },
      error: function (xhr, status) {
        console.log('fail');
        reject(xhr);
      }
    });
  });
}

function change_from_cart_gift(variantid, qty) {
  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + qty + "&id=" + variantid,
      dataType: "json",
      success: function (response) {
        var cart = new theme.CartDrawer();
        cart.init();
        resolve(response);
      },
      error: function (xhr, status) {
        console.log('fail');
        reject(xhr);
      }
    });
  });
}

// Función personalizada para manejar paths específicos
async function handlePathRegaloSorpresa(path) {
    console.log(path)
    if (path.includes("regalosorpresa")) {
        const regalosSorpresaVaraintsIds = ["46917897978107","46917896503547"]
        console.log(regalosSorpresaVaraintsIds)
        const disponibles = await window.getAvailableVariants(regalosSorpresaVaraintsIds);
        console.log(disponibles)
        if (!disponibles.length) {
            console.log("No hay variantes disponibles.");
        } else {
          const varianteAleatoria = window.getRandomElement(disponibles);
          window.setCookie('regaloSorpresa',varianteAleatoria)
        }
    } 
}



async function handlePathExcludeExitPopUp(path) {
    if (path.includes("whatsapp")) {
        setCookie_CartGifts('exclude_exit_popup',true)
    } 
}


// Función personalizada para manejar paths específicos
async function handlePathDebug(path) {
    if (path.includes("fdvdebug")) {
          setCookie_CartGifts('fdvdebug',true)
        }
    } 


async function handlePathConfetti(path) {
    if (path.includes("confetti")) {
          add_to_cart_gift("46913617789179","1")
          change_from_cart_gift("46913617789179","1")

        }
    } 

// Función personalizada para manejar paths específicos
async function handlePathSahumerio(path) {
    if (path.includes("iniciacion")) {
          add_to_cart_gift("46913617789179","1")
          change_from_cart_gift("47250497962235","1")
        }
    } 

async function handlePathRegaloSorpresaXl(path) {
    if (path.includes("regalosorpresaxl")) {
          add_to_cart_gift("47540297072891","1")
          change_from_cart_gift("47540297072891","1")
        }
    } 
    


window.getVariantInventory = function(variantId) {
    return new Promise((resolve, reject) => {
        fetch(`/products.json`)
            .then(response => response.json())
            .then(data => {
                let foundVariant = null;

                // Buscar la variante en todos los productos cargados en la tienda
                data.products.forEach(product => {
                    const variant = product.variants.find(v => v.id === parseInt(variantId, 10));
                    if (variant) {
                        foundVariant = variant;
                    }
                });

                if (foundVariant) {
                    resolve(foundVariant);
                } else {
                    reject("Variante no encontrada");
                }
            })
            .catch(error => reject(error));
    });
};

window.getAvailableVariants = async function(variantIds) {
    const availableVariants = [];

    for (const variantId of variantIds) {
        try {
            const variant = await window.getVariantInventory(variantId);
            if (variant.available) {
                availableVariants.push(variantId);
            }
        } catch (error) {
            console.error(`Error al obtener la variante ${variantId}:`, error);
        }
    }

    return availableVariants;
};

window.getRandomElement = function(arr) {
    if (arr.length === 0) return null;
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
};


const currentUrl = window.location.href;
//handlePathExcludeExitPopUp(currentUrl);
//handlePathRegaloSorpresaXl(currentUrl)
//handlePathDebug(currentUrl);


